import { ITEMS_BASE_CLASS, ITEM_BASE_CLASS } from "../constants.js";

export default class LocationSearchItems {
  constructor(container, store, eventBus) {
    this.container = container;
    this.store = store;
    this.eventBus = eventBus;

    this.locationItemElements = this.container
      ? Array.from(this.container.querySelectorAll(`.${ITEM_BASE_CLASS}`))
      : [];

    this.addEventListeners();
    this.addClickHandlers();
    this.render();
  }

  addEventListeners() {
    this.eventBus.on("locationTypeFiltersChanged", this.render.bind(this));
    this.eventBus.on("locationMinimumCapacityChanged", this.render.bind(this));
    this.eventBus.on("locationSelectedLineupChanged", this.render.bind(this));
  }
  
  addClickHandlers() {
    this.locationItemElements.forEach((item) => {
      item.addEventListener('click', (event) => this.handleLocationClick(event, item));
    });
  }
  
  handleLocationClick(event, item) {
      event.preventDefault();
      
      const locationId = item.dataset.id || item.dataset.locationId;
      this.store.analytics.trackLocationClick(locationId);
      
      const linkElement = event.target.closest('a');
      if (linkElement) window.location.href = linkElement.href;
  }

  render() {
    this.toggleContainerVisibility();
    this.updateLabels();
    this.updateLocationCount();
    this.updateEventLabels();
    this.updateLocationItems();
  }

  toggleContainerVisibility() {
    const activeType = this.store.activeTypeValue;
    this.container?.classList.toggle("d-none", !activeType || this.store.minimumCapacity === 0);
  }

  updateLabels() {
    const activeLocations = this.store.getActiveLocations();
    const locationCount = activeLocations.length;

    const labelMultiple = this.container?.querySelector(`.${ITEMS_BASE_CLASS}__label-multiple`);
    const labelSingle = this.container?.querySelector(`.${ITEMS_BASE_CLASS}__label-single`);
    const isMultiple = locationCount > 1;

    labelMultiple?.classList.toggle("d-none", !isMultiple);
    labelMultiple?.classList.toggle("d-block", isMultiple);
    labelSingle?.classList.toggle("d-none", isMultiple);
    labelSingle?.classList.toggle("d-block", !isMultiple);
  }

  updateLocationCount() {
    const activeLocations = this.store.getActiveLocations();
    const locationCount = activeLocations.length;

    const countElement = this.container?.querySelector(`.${ITEMS_BASE_CLASS}__count-number`);
    if (countElement) {
      countElement.textContent = locationCount;
    }
  }

  updateEventLabels() {
    const activeType = this.store.activeTypeValue;
    const eventLabelElements = this.container?.querySelectorAll(`.${ITEMS_BASE_CLASS}__event-label`);
    eventLabelElements?.forEach((el) => {
      el.textContent = activeType ? activeType.toLowerCase() : "event";
    });
  }

  updateLocationItems() {
    const activeLocations = this.store.getActiveLocations();
    const activeLocationIds = activeLocations.map((loc) => loc.id);
    this.locationItemElements.forEach((locEl) => {
      const isActive = activeLocationIds.includes(locEl.dataset.id);
      locEl.classList.toggle(`${ITEM_BASE_CLASS}--active`, isActive);
    });
  }
}